module.exports = __webpack_public_path__ + "main/assets/public/email/instagram-logo.21c49c40fc4e3ad0.png";